import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <div className={styles.container}>
            <Link to="/my-deliveries">
                <i className={styles.icon + " fas fa-image"}></i>
            </Link>
            <Link to="/">
                <i className={styles.icon + " fas fa-home"}></i>
            </Link>
            <Link to="/my-account">
                <i className={styles.icon + " fas fa-user"}></i>
            </Link>
        </div>
    )
}

export default Footer
